window.triggerNativeEvent = function(el, eventName) {
  if (el.fireEvent) { // < IE9
    (el.fireEvent('on' + eventName));
  } else {
    let evt = document.createEvent('Events');
    evt.initEvent(eventName, true, false);
    el.dispatchEvent(evt);
  }
};

window.extend = function() {
  let result = {}, obj;

  for (let i = 0; i < arguments.length; i++) {
    obj = arguments[i];
    for (let key in obj) {
      if (Object.prototype.toString.call(obj[key]) === '[object Object]') {
        if (typeof result[key] === 'undefined') {
          result[key] = {};
        }
        result[key] = extend(result[key], obj[key]);
      }
      else {
        result[key] = obj[key];
      }
    }
  }
  return result;
};

export function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, {type: contentType});
  return blob;
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils.js